import * as Yup from "yup";

import { createForm } from "../../forms";

import type { TypeSafeReactLocalization } from "../../../composites";

export type NpsFormValues = Record<string, string | number> & {
  surveyId: string;
  impressionId: string;
};

export const getInitialValidationShape = ({
  getString,
}: TypeSafeReactLocalization): Yup.ObjectShape => ({
  surveyId: Yup.string().required(
    getString("form-generic-validation-required"),
  ),
  impressionId: Yup.string().required(
    getString("form-generic-validation-required"),
  ),
});

const translateValidationSchema = (l10n: TypeSafeReactLocalization) =>
  Yup.object().shape(getInitialValidationShape(l10n));

const initialValues: NpsFormValues = { surveyId: "", impressionId: "" };

export const NpsForm = createForm({
  initialValues,
  translateValidationSchema,
});
